import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';

import bgImg from '../assets/img/beijing_wenzhen_icon@3x.png';
import phoneIcon from '../assets/icon/shouji_denglu_white_icon@3x.png';
import lockIcon from '../assets/icon/mima_denglu_white_icon@3x.png';
import companyLogo from '../assets/icon/company-logo-color.png';
import ContentWrapper from '../components/content-wrapper';
import { LargeButton, WhiteLargePrimaryButton } from '../components/button';
import IconField, { LightBackgroundField } from '../components/input-field';
import TitledComponent from '../components/titled-component';
import { connect } from 'react-redux';
import { Field, propTypes, reduxForm, reset, destroy } from 'redux-form';
import {
    cellphoneNumberNormalizer,
    cellphoneNumberValidator, parseError, passwordLengthValidator,
} from '../validator';
import { MEDICAL_HISTORY_FORM_NAME } from './medical-history';
import { REGISTER_FORM_NAME } from './register';
import { RESET_PASSWORD_FORM_NAME } from './reset-password';
import { login, setMedicalHistoryInitial } from '../actions/user';
// import {toast} from "react-toastify/index";

const LoginContainer = styled(ContentWrapper)`
  position: relative;
  min-height: 100%;
  height: auto;
  background-image: url(${bgImg});
  background-size: cover;
  overflow-y: visible;
  /* cancel margin collapse */
  border: 1px solid transparent;
`;

const LoginFormComponent = LoginContainer.withComponent('form');

const LogoWrapper = styled.div`
  margin-top: 150px;
  margin-bottom: 80px;
`;

const Logo = styled.div`
  margin: 0 auto;
  width: 180px;
  height: 180px;
  background: white;
  border-radius: 50%;
  
  img {
    max-width: 80%;
    margin-top: 50%;
    margin-left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const RightLink = styled.div`
  width: 100%;
  padding: 30px 0 40px 538px;
`;

RightLink.a = styled.a`
  color: white;
  font-size: 24px;
  &, &:focus, &:active,
  &:visited, &:hover {
    text-decoration: none !important;
    outline: none !important;
    background: none !important;
  }
`;

class _LoginForm extends React.Component {
    render() {
        const {
            handleSubmit,
            onForget, onRegister,
        } = this.props;
        return (
            <LoginFormComponent onSubmit={handleSubmit}>
                <LogoWrapper>
                    <Logo>
                        <img alt='logo' src={companyLogo} />
                    </Logo>
                </LogoWrapper>

                <IconField>
                    <IconField.Label>手机号</IconField.Label>
                    <Field
                        name='cellphone'
                        validate={cellphoneNumberValidator}
                        normalize={cellphoneNumberNormalizer}
                        component={LightBackgroundField.Input}
                        type='number'
                        pattern='\d*' />
                    <IconField.Icon src={phoneIcon} style={{ width: '26px', height: '40px' }} />
                </IconField>

                <IconField>
                    <IconField.Label>密&nbsp;&nbsp;&nbsp;码</IconField.Label>
                    <Field
                        name='password'
                        validate={passwordLengthValidator}
                        component={LightBackgroundField.Input}
                        type='password'
                    />
                    <IconField.Icon src={lockIcon} style={{ width: '34px', height: '40px', left: '31px' }} />
                </IconField>

                <RightLink>
                    <RightLink.a onClick={onForget}>
                        忘记密码？
                    </RightLink.a>
                </RightLink>

                <WhiteLargePrimaryButton
                    type="submit"
                >
                    登录/挂号
                </WhiteLargePrimaryButton>
                <LargeButton onClick={onRegister} type='button'>
                    新用户注册
                </LargeButton>
            </LoginFormComponent>
        );
    }
}

_LoginForm.defaultProps = {
};

_LoginForm.propTypes = {
    ...propTypes,
    onForget: PropTypes.func.isRequired,
    onRegister: PropTypes.func.isRequired,
};

export const LOGIN_FORM_NAME = 'login';

const LoginForm = reduxForm({
    form: LOGIN_FORM_NAME, // a unique name for this form
    onSubmitFail: (e) => {
        alert(parseError(e))
    },
})(_LoginForm);

class Login extends TitledComponent {
    onRegister() {
        this.props.dispatch(setMedicalHistoryInitial(null));
        this.props.dispatch(reset(REGISTER_FORM_NAME));
        this.props.dispatch(destroy(MEDICAL_HISTORY_FORM_NAME));
        this.goto('/register');
    }

    onForget() {
        this.props.dispatch(reset(RESET_PASSWORD_FORM_NAME));
        this.goto('/resetpassword');
    }

    onSubmit(e) {
        this.props.dispatch(login(e.cellphone, e.password));
    }

    render() {
        return (
            <LoginForm
            onForget={() => this.onForget()}
            onRegister={() => this.onRegister()}
            onSubmit={e => this.onSubmit(e)}
            >

            </LoginForm>

        );
    }
}

Login.defaultProps = {
    title: '登陆',
};

export default connect()(Login);



// WEBPACK FOOTER //
// ./src/scene/login.jsx